import { largeTitle } from 'common/styles/mixins/typography';
import styled from 'styled-components';

export const GeneralInfoTextContainer = styled.div`
  margin: 30px 120px 30px 50px;
  padding: 40px 30px;
  background-color: #f3f3f0;

  & p {
    line-height: 24px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const GeneralInfoTitle = styled.h3`
  color: ${({ theme }) => theme.colors.bodyText};
  margin: 0;
  ${largeTitle}
`;
